import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminPayments() {
  const [invoices, setInvoices] = useState([]);
  useEffect(() => { api.get("/admin/payments").then((r) => setInvoices(r.data)); }, []);

  const total = invoices.reduce((s, i) => s + (i.amount || 0), 0);

  return (
    <div className="px-5 lg:px-10 py-8 max-w-6xl mx-auto">
      <h1 className="text-3xl font-bold text-brand-navy">Payments</h1>
      <p className="text-sm text-brand-muted mt-1">Total revenue: <span className="font-bold text-brand-navy">₹{total.toLocaleString()}</span></p>

      <div className="mt-6 bg-white rounded-2xl border border-brand-borderc overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-brand-surface text-brand-navy">
            <tr className="text-left">
              <th className="px-4 py-3">Invoice</th>
              <th className="px-4 py-3">Plan</th>
              <th className="px-4 py-3">Provider</th>
              <th className="px-4 py-3">Amount</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-brand-borderc">
            {invoices.length === 0 ? (
              <tr><td colSpan="6" className="text-center py-10 text-brand-muted">No invoices yet</td></tr>
            ) : invoices.map((i) => (
              <tr key={i.id}>
                <td className="px-4 py-3 font-mono text-xs">{i.id.slice(0, 8)}</td>
                <td className="px-4 py-3 capitalize">{i.plan}</td>
                <td className="px-4 py-3 capitalize">{i.provider}</td>
                <td className="px-4 py-3 font-bold">₹{i.amount}</td>
                <td className="px-4 py-3"><span className="text-xs px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 capitalize">{i.status}</span></td>
                <td className="px-4 py-3 text-xs text-brand-muted">{new Date(i.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
